<template>
  <h2 class="pb-2 border-bottom">Terapia de Reposição Hormonal (HRT)</h2>
  <p>Cuidado Personalizado para Equilíbrio e Vitalidade</p>
  <p>Na Diverse Care Now, oferecemos terapias hormonais seguras e supervisionadas para homens e mulheres. Nosso objetivo é restaurar o equilíbrio, aumentar a energia e promover bem-estar por meio de planos personalizados.</p>
  <h3>Categorias</h3>
  <ul>
    <li>Mulheres: terapia com estrogênio & progesterona, hormônios bioidênticos, suporte tireoidiano.</li>
    <li>Homens: reposição de testosterona (TRT), otimização da tireoide, suporte adrenal.</li>
    <li>Ambos: terapias com peptídeos para vitalidade, suporte adrenal e controle do estresse.</li>
  </ul>
  <h3>Formas de administração</h3>
  <ul>
    <li>Injeções (semanais ou quinzenais).</li>
    <li>Pellets (liberação prolongada de 3–6 meses).</li>
    <li>Cremes/géis (uso diário).</li>
    <li>Medicamentos orais (menos comuns, usados em casos específicos).</li>
  </ul>
  <h3>Monitoramento & segurança</h3>
  <ul>
    <li>Exames laboratoriais completos (hormônios, tireoide, marcadores metabólicos).</li>
    <li>Consulta inicial e planejamento terapêutico.</li>
    <li>Acompanhamento contínuo e ajustes de dosagem.</li>
    <li>Follow-up por telemedicina.</li>
  </ul>
  <p>“A terapia hormonal não é igual para todos — cada plano é adaptado às suas necessidades únicas, sempre com supervisão médica.”</p>
</template>

<script>
export default {
  name: 'HormoneReplacementContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
